import { useEffect } from "react";
import Header from "@/components/forest/Header";
import Hero from "@/components/forest/Hero";
import Features from "@/components/forest/Features";
import HowItWorks from "@/components/forest/HowItWorks";
import OrderForm from "@/components/forest/OrderForm";
import Footer from "@/components/forest/Footer";
import Fireflies from "@/components/forest/Fireflies";

export default function Home() {
  useEffect(() => {
    document.title = "forestdays.shop — 99 Nights in the Forest Bundle";
  }, []);

  return (
    <div data-testid="home-page" className="relative min-h-screen overflow-hidden">
      {/* atmospheric backdrops */}
      <div className="pointer-events-none fixed inset-0 -z-10">
        <div
          className="absolute inset-0 opacity-30 mist-layer"
          style={{
            backgroundImage:
              "url('https://images.pexels.com/photos/13396070/pexels-photo-13396070.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1600')",
            backgroundSize: "cover",
            backgroundPosition: "center",
            filter: "blur(2px) brightness(0.45)",
          }}
        />
        <div className="absolute inset-0 bg-[#040B11]/80" />
        <div className="absolute inset-0 grain opacity-25" />
      </div>

      <Fireflies count={22} />

      <Header />
      <main>
        <Hero />
        <Features />
        <HowItWorks />
        <OrderForm />
      </main>
      <Footer />
    </div>
  );
}
